import React from "react";
import { Link } from "react-router-dom";
import './componentsCss/ShortCuts.css'

function Shortcuts({ icon, navigate, infoTitle }) {
    return (
        <div className="shotcuts-container">
            <Link to={navigate}>
                <div className="shortcuts">
                    <img alt="icon" src={icon} />
                    <div>{infoTitle}</div>
                </div>
            </Link>
        </div>
    )
}

export default Shortcuts;